import {MENUS} from "../menu";

export const ROUTER_NAMES = {
    CHAT: 'Chat'
}

export default [
    {
        name: ROUTER_NAMES.CHAT,
        path: '/chat',
        meta: {
            menu: MENUS.FUNCIONALIDAES,
            title: 'Chats',
            searchAlias: 'Chats',
            searchDescription: 'Veja todos os Chats disponíveis',
            searchTerms: ['Chat'],
            hasRole: 'role/chat'
        },
        component: () => import('@/views/Chat')
    },
]